import { useState, useCallback } from 'react';

/**
 * Hook que centraliza el rango de fechas por defecto (últimos 30 días).
 * Devuelve { rangeKey, startDate, endDate, setRange }.
 */
export default function useDefaultRange(initialKey = '30d') {
  const [state, setState] = useState(() => {
    const today = new Date();
    const end = today.toISOString().split('T')[0];
    const start = new Date(today.setDate(today.getDate() - 29))
      .toISOString()
      .split('T')[0];

    return {
      rangeKey: initialKey,
      startDate: start,
      endDate: end,
    };
  });

  const setRange = useCallback((payload) => {
    setState((prev) => ({ ...prev, ...payload }));
  }, []);

  return {
    rangeKey: state.rangeKey,
    startDate: state.startDate,
    endDate: state.endDate,
    setRange,
  };
}
